import Vue from 'vue';
/* import ViewModelBase from '@src/core/v2/app/viewModelBase'; */

export default class PLocationViewModel {
  googleWindow = window as any;
  apiKey = '' as String;
  googleMapsVersion = '' as string;
  googleMapsMapId = '' as string;
  map = undefined as any;
  marker = undefined as any;
  mapHtmlElement = {} as HTMLElement;
  searchHtmlInputElement = {} as HTMLInputElement;
  searchBox = undefined as any;
  longitude = 0 as number;
  latitude = 0 as number;
  zoom = 0 as number;
  setMarker = true as boolean;
  isInEditMode = false as boolean;
  previousLatitude = 0 as number;
  previousLongitude = 0 as number;

  initializeGoogleMapsConfigruations() {
    this.apiKey = Vue.$config.values['google-maps-api-key'] ?? '';
    this.googleMapsVersion = Vue.$config.values['google-maps-map-version'] ?? '';
    this.googleMapsMapId = Vue.$config.values['google-maps-map-id'] ?? '';
  }

  async initializeGoogleMaps() {
    if (!window.google) {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places&loading=async&v=${this.googleMapsVersion}`;
      document.head.appendChild(script);
    }
    const googleCheckerHndl = setInterval(async () => {
      if (window.google) {
        this.googleWindow = window.google;
        clearInterval(googleCheckerHndl);
        await window.google.maps.importLibrary('marker');
        this.setupMap();
        this.setupMarker();
      }
    }, 100);
  }
  setupMap() {
    this.map = new this.googleWindow.maps.Map(this.mapHtmlElement, {
      center: { lat: this.latitude, lng: this.longitude },
      mapTypeId: this.googleWindow.maps.MapTypeId.SATELLITE,
      disableDefaultUI: true,
      zoom: this.zoom,
      mapId: this.googleMapsMapId,
    });
  }
  setupMarker() {
    const self = this;

    this.googleWindow.maps.event.addListener(this.map, 'click', (event: any) => {
      if (self.isInEditMode) {
        self.drawMarker(event.latLng.lat(), event.latLng.lng());
      }
    });

    if (self.setMarker) {
      this.drawMarker(this.latitude, this.longitude);
    }
  }
  drawMarker(lat: number, lng: number) {
    const latLng = new this.googleWindow.maps.LatLng(lat, lng);

    if (this.marker === undefined) {
      this.marker = new this.googleWindow.maps.marker.AdvancedMarkerElement({
        position: latLng,
        map: this.map,
      });
    } else {
      this.marker.position = latLng;
    }

    this.latitude = lat;
    this.longitude = lng;
  }
  updateGoogleMap() {
    if (!this.googleWindow.maps || !Number(this.latitude) || !Number(this.longitude)) {
      return;
    }
    const panPoint = new this.googleWindow.maps.LatLng(this.latitude, this.longitude);
    this.map.panTo(panPoint);
    this.drawMarker(this.latitude, this.longitude);
  }
  setViewMode() {
    this.isInEditMode = false;
    this.map.setOptions({ disableDefaultUI: true });
    // this.clearSearch();
  }
  onCancel() {
    this.latitude = this.previousLatitude;
    this.longitude = this.previousLongitude;
    this.updateGoogleMap();
    this.setViewMode();
  }
  clearSearch() {
    this.googleWindow.maps.event.clearListeners(this.searchBox, 'places_changed');
  }
}
